import Swal from 'sweetalert2'

import { lang } from '../../assets/lang'
import { facebookMediaHtml } from './facebookMediaHtml'
import {
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../functions/utils'

export const facebookMediaModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.facebook_media_modal_title,
    html: facebookMediaHtml,

    willOpen: () => {
      const mediaUrl = oldData.mediaUrl || ''
      $('#fb-media-url').val(mediaUrl)

      // Handles old data of delay system
      handleOldDataOfDelay(oldData)
    },

    preConfirm: () => {
      const mediaUrl = $('#fb-media-url').val()

      if (! mediaUrl) {
        Swal.showValidationMessage(lang.facebook_media_modal_msg_media_url)
      }

      const delayData = handleDataOfDelay()

      return {
        mediaUrl,
        ...delayData,
      }
    }, 
  })
}